(function () {
  var root = document.querySelector('[data-fbd]');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var variants = [];
  try {
    variants = JSON.parse(document.getElementById('fbdVariants').textContent);
  } catch (e) { variants = []; }

  var stage = root.querySelector('#fbdStage');
  var priceEl = root.querySelector('#fbdPrice');
  var wasEl = root.querySelector('#fbdWas');
  var idInput = root.querySelector('#fbdVariantId');
  var addBtn = root.querySelector('#fbdAdd');
  var addLabel = root.querySelector('#fbdAddLabel');
  var barPrice = document.querySelector('#fbdBarPrice');
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-opt-index]'));
  var selected = groups.map(function (g) {
    var on = g.querySelector('[data-value].on');
    return on ? on.dataset.value : null;
  });

  function findVariant(sel) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] !== null && v.options[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function refreshAvailability() {
    groups.forEach(function (g, gi) {
      g.querySelectorAll('[data-value]').forEach(function (btn) {
        var probe = selected.slice();
        probe[gi] = btn.dataset.value;
        var hit = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < probe.length; j++) {
            if (probe[j] !== null && v.options[j] !== probe[j]) { ok = false; break; }
          }
          if (ok) { hit = v; break; }
        }
        btn.classList.toggle('na', !hit || !hit.available);
      });
    });
  }

  function swapImage(src) {
    var img = stage && stage.querySelector('img');
    if (!img || !src || img.getAttribute('src') === src) return;
    if (reduce) { img.src = src; return; }
    img.classList.add('swapping');
    setTimeout(function () {
      img.src = src;
      img.onload = function () { img.classList.remove('swapping'); };
      setTimeout(function () { img.classList.remove('swapping'); }, 500);
    }, 190);
  }

  function apply() {
    var v = findVariant(selected);
    if (!v) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable';
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) {
      priceEl.textContent = v.price;
      priceEl.classList.remove('flash');
      void priceEl.offsetWidth;
      if (!reduce) priceEl.classList.add('flash');
    }
    if (wasEl) {
      if (v.compare) { wasEl.textContent = v.compare; wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }
    if (addBtn) addBtn.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? 'Add to bag · ' + v.price : 'Sold out';
    if (barPrice) barPrice.textContent = v.price;
    if (v.image) swapImage(v.image);

    if (window.history && history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }

    groups.forEach(function (g, gi) {
      var lbl = g.querySelector('[data-opt-current]');
      if (lbl) lbl.textContent = selected[gi] || '';
    });

    refreshAvailability();
  }

  groups.forEach(function (g, gi) {
    g.querySelectorAll('[data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('na')) return;
        g.querySelectorAll('[data-value]').forEach(function (x) { x.classList.remove('on'); });
        btn.classList.add('on');
        selected[gi] = btn.dataset.value;
        apply();
      });
    });
  });

  root.querySelectorAll('.fbd-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      root.querySelectorAll('.fbd-thumb').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      swapImage(t.dataset.full);
    });
  });

  var qty = root.querySelector('#fbdQty');
  root.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qty) return;
      var n = parseInt(qty.value, 10) || 1;
      n += (b.dataset.qty === 'up' ? 1 : -1);
      if (n < 1) n = 1;
      if (n > 99) n = 99;
      qty.value = n;
    });
  });

  var form = root.querySelector('#fbdForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var body = new FormData(form);
      var original = addLabel ? addLabel.textContent : '';
      if (addLabel) addLabel.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (addBtn) addBtn.classList.add('done');
          if (addLabel) addLabel.textContent = 'Added to bag ✓';
          var toast = document.querySelector('.fb-toast');
          if (toast) {
            toast.textContent = 'Added to your bag';
            toast.classList.add('on');
            setTimeout(function () { toast.classList.remove('on'); }, 2400);
          }
          setTimeout(function () {
            if (addBtn) addBtn.classList.remove('done');
            if (addLabel) addLabel.textContent = original;
          }, 2400);
        })
        .catch(function () {
          if (addLabel) addLabel.textContent = original;
          form.submit();
        });
    });
  }

  var bar = document.querySelector('.fbd-bar');
  var anchor = root.querySelector('.fbd-actions');
  if (bar && anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    var barBtn = bar.querySelector('button');
    if (barBtn && form) barBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  refreshAvailability();
})();
